/** @enum string */
const ResidenceType = Object.freeze({
  RESIDENTE: 'R',
  EUROPEO: 'U',
  EXTRANJERO: 'E'
})

export default ResidenceType
